import http from 'services/http-service';
import { getStorage } from "utils/storage-utils";

const OrderService = {

    InitialCheckout(name: string, email: string, phoneNumber: string, productId: string,) {
        var affiliate = getStorage('logos.aid');
        var response = http.post(`/orders/InitialCheckout`, { name: name, email: email, phoneNumber: phoneNumber, productId: productId, affiliate: affiliate });
        return response;
    },

    Checkout(name: string, email: string, phoneNumber: string, productId: string, voucher: string, paymentMethod: number) {
        var affiliate = getStorage('logos.aid') || "";
        var utmSource = getStorage('logos.utm_source') || "";
        var utmMedium = getStorage('logos.utm_medium') || "";
        var utmCampaign = getStorage('logos.utm_campaign') || "";
        var response = http.post(`/orders/public`, {
            name: name,
            email: email,
            phoneNumber: phoneNumber,
            programId: productId,
            voucher: voucher,
            affiliate: affiliate,
            paymentMethod: paymentMethod,
            utmSource: utmSource,
            utmMedium: utmMedium,
            utmCampaign: utmCampaign
        });
        return response;
    },

    GetOrderByInvoice(invoiceNo: any) {
        let response = http.get(`/orders/invoice/${invoiceNo}/simple`);
        return response;
    },

    GenerateMidtransToken(orderId: string) {
        let response = http.post('/orders/midtransToken', { orderId: orderId });
        return response;
    }
};

export default OrderService;